/* The Folks — site-wide image lightbox.
   Groups images per section, opens in an overlay with prev/next,
   keyboard control, swipe on touch and a thumbnail rail.        */
(function () {
  'use strict';

  /* images that open in the viewer */
  var SEL_ZOOM = [
    '[data-lb-group] img',
    'figure.fk-media img',
    '.artbody img',
    '.product__media-item img',
    '.product-media-container img'
  ].join(',');
  /* how far up we look to decide which images belong together */
  var SEL_SCOPE = '[data-lb-group], .shopify-section, main';
  var box = null;
  var els = { stage: null, img: null, cap: null, rail: null, count: null, prev: null, next: null };
  var items = [];
  var idx = 0;
  var lastFocus = null;

  /* ---------- collecting ---------- */

  function bestSrc(img) {
    return img.getAttribute('data-lb-src') || img.currentSrc || img.src || '';
  }

  function fullSrc(img) {
    var s = bestSrc(img);
    if (!s) return '';
    /* ask the Shopify CDN for a big rendition */
    if (s.indexOf('/cdn/shop/') > -1 || s.indexOf('cdn.shopify.com') > -1) {
      s = s.replace(/([?&])width=\d+/, '$1width=2000');
      if (s.indexOf('width=') === -1) s += (s.indexOf('?') > -1 ? '&' : '?') + 'width=2000';
    }
    return s;
  }

  function collect(from) {
    var scope = from.closest(SEL_SCOPE) || document.body;
    var imgs = Array.prototype.slice.call(scope.querySelectorAll(SEL_ZOOM));
    if (imgs.indexOf(from) === -1) imgs = [from].concat(imgs);
    imgs = imgs.filter(function (im) {
      if (im.closest('[data-lb-skip]')) return false;
      if (im.closest('.pcard') || im.closest('.jcard')) return im === from;
      var r = im.getBoundingClientRect();
      return r.width === 0 ? im.naturalWidth > 200 : r.width > 100;
    });
    return imgs.map(function (im) {
      return {
        src: fullSrc(im),
        alt: im.getAttribute('alt') || '',
        thumb: bestSrc(im),
        node: im
      };
    }).filter(function (o) { return o.src; });
  }

  /* ---------- building ---------- */

  function build() {
    if (box) return;
    box = document.createElement('div');
    box.className = 'fbx';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Image viewer');
    box.innerHTML =
      '<button class="fbx__close" type="button" aria-label="Close">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round"/></svg></button>' +
      '<button class="fbx__nav fbx__nav--prev" type="button" aria-label="Previous image">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M15 4L7 12l8 8" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<button class="fbx__nav fbx__nav--next" type="button" aria-label="Next image">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M9 4l8 8-8 8" stroke="currentColor" stroke-width="1.6" fill="none" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<figure class="fbx__stage"><img class="fbx__img" alt=""><figcaption class="fbx__cap"></figcaption></figure>' +
      '<div class="fbx__bar"><div class="fbx__rail"></div><span class="fbx__count"></span></div>';
    document.body.appendChild(box);

    els.stage = box.querySelector('.fbx__stage');
    els.img = box.querySelector('.fbx__img');
    els.cap = box.querySelector('.fbx__cap');
    els.rail = box.querySelector('.fbx__rail');
    els.count = box.querySelector('.fbx__count');
    els.prev = box.querySelector('.fbx__nav--prev');
    els.next = box.querySelector('.fbx__nav--next');

    box.querySelector('.fbx__close').addEventListener('click', close);
    els.prev.addEventListener('click', function () { go(-1); });
    els.next.addEventListener('click', function () { go(1); });
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target === els.stage) close();
    });

    /* swipe */
    var x0 = null, y0 = null;
    box.addEventListener('touchstart', function (e) {
      x0 = e.touches[0].clientX; y0 = e.touches[0].clientY;
    }, { passive: true });
    box.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      var dy = e.changedTouches[0].clientY - y0;
      if (Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
      else if (dy > 90) close();
      x0 = y0 = null;
    });
  }

  /* ---------- rendering ---------- */

  function paint() {
    var it = items[idx];
    els.img.classList.remove('is-in');
    var pre = new Image();
    pre.onload = function () {
      els.img.src = it.src;
      els.img.alt = it.alt;
      requestAnimationFrame(function () { els.img.classList.add('is-in'); });
    };
    pre.src = it.src;
    if (pre.complete) pre.onload();

    els.cap.textContent = it.alt;
    els.cap.hidden = !it.alt;
    els.count.textContent = (idx + 1) + ' / ' + items.length;

    var multi = items.length > 1;
    els.prev.hidden = !multi;
    els.next.hidden = !multi;
    box.querySelector('.fbx__bar').hidden = !multi;

    Array.prototype.forEach.call(els.rail.children, function (b, i) {
      b.classList.toggle('is-on', i === idx);
      if (i === idx) b.setAttribute('aria-current', 'true');
      else b.removeAttribute('aria-current');
    });

    /* preload neighbours */
    [idx - 1, idx + 1].forEach(function (i) {
      if (items[i]) { var p = new Image(); p.src = items[i].src; }
    });
  }

  function rail() {
    els.rail.innerHTML = '';
    if (items.length < 2) return;
    items.forEach(function (it, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'fbx__thumb';
      b.setAttribute('aria-label', 'Image ' + (i + 1));
      b.innerHTML = '<img src="' + it.thumb + '" alt="" loading="lazy">';
      b.addEventListener('click', function () { idx = i; paint(); });
      els.rail.appendChild(b);
    });
  }

  function go(step) {
    if (items.length < 2) return;
    idx = (idx + step + items.length) % items.length;
    paint();
  }

  /* ---------- open / close ---------- */

  function open(list, start) {
    if (!list.length) return;
    build();
    items = list;
    idx = Math.max(0, Math.min(start || 0, items.length - 1));
    lastFocus = document.activeElement;
    rail();
    paint();
    document.documentElement.classList.add('fbx-open');
    box.classList.add('is-on');
    document.addEventListener('keydown', onKey);
    setTimeout(function () { box.querySelector('.fbx__close').focus(); }, 40);
  }

  function close() {
    if (!box) return;
    box.classList.remove('is-on');
    document.documentElement.classList.remove('fbx-open');
    document.removeEventListener('keydown', onKey);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); }
    else if (e.key === 'ArrowRight') { e.preventDefault(); go(1); }
    else if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); }
  }

  /* ---------- wiring ---------- */

  function fromImage(img) {
    var list = collect(img);
    var at = 0;
    for (var i = 0; i < list.length; i++) if (list[i].node === img) { at = i; break; }
    open(list, at);
  }

  document.addEventListener('click', function (e) {
    /* Dawn's product zoom button */
    var zoom = e.target.closest && e.target.closest('.product__media-toggle, .product__modal-opener');
    if (zoom) {
      var holder = zoom.closest('.product-media-container') || zoom.parentElement;
      var zimg = holder && holder.querySelector('img');
      if (zimg) { e.preventDefault(); e.stopPropagation(); fromImage(zimg); return; }
    }

    /* a link that points straight at an image file */
    var a = e.target.closest && e.target.closest('a');
    if (a && /\.(jpe?g|png|webp|gif|avif)(\?|$)/i.test(a.getAttribute('href') || '')) {
      var aimg = a.querySelector('img');
      e.preventDefault();
      if (aimg) fromImage(aimg);
      else open([{ src: a.href, alt: a.getAttribute('aria-label') || '', thumb: a.href }], 0);
      return;
    }

    /* any image we marked as zoomable */
    var img = e.target.closest && e.target.closest(SEL_ZOOM);
    if (img && !e.target.closest('a') && !e.target.closest('button')) {
      e.preventDefault();
      fromImage(img);
    }
  }, true);

  /* mark images as interactive */
  function mark() {
    document.querySelectorAll(SEL_ZOOM).forEach(function (im) {
      if (im.closest('[data-lb-skip]') || im.closest('a') || im.dataset.lbReady) return;
      im.dataset.lbReady = '1';
      im.classList.add('is-zoomable');
      im.setAttribute('role', 'button');
      im.setAttribute('tabindex', '0');
      im.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); fromImage(im); }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', mark);
  else mark();
  window.folksLightboxRefresh = mark;
  window.folksLightbox = open;
})();
